import { Model } from "../hooks/useFile";
import { IframeMessageData } from "../types/iframeMessage";

/**
 * 모델을 status 순서대로 정렬 (public > beta > private)
 *
 * @param models - 정렬할 모델 배열
 * @returns 정렬된 모델 배열
 */
export const sortModelsByStatus = (
  models: IframeMessageData["accessibleModel"],
) => {
  if (!models) return [];

  return models.sort((a, b) => {
    const statusOrder = { public: 1, beta: 2, private: 3 };
    if (a.status && b.status) {
      const statusA = statusOrder[a.status as keyof typeof statusOrder];
      const statusB = statusOrder[b.status as keyof typeof statusOrder];
      if (statusA !== statusB) {
        return statusA - statusB;
      }
    }
    return a.name.localeCompare(b.name);
  });
};

/**
 * 콘솔 모델 데이터를 앱 모델 형식으로 변환
 *
 * @param consoleModel - 부모 창으로부터 수신된 모델 데이터
 * @returns 앱에서 사용할 수 있는 Model 객체
 */
export const transformConsoleModelToAppModel = (
  consoleModel: NonNullable<IframeMessageData["accessibleModel"]>[0],
): Model => ({
  name: consoleModel.name,
  type: consoleModel.modelType ?? consoleModel.path,
  serviceName: consoleModel.service,
  url: consoleModel.name,
  status: consoleModel.status,
});

/**
 * webpackOk 메시지인지 확인하는 타입 가드
 *
 * @param data - 확인할 메시지 데이터
 * @returns webpackOk 메시지인 경우 true
 */
export const isWebpackOkMessage = (
  data: any,
): data is { type: "webpackOk" } => {
  return data?.type === "webpackOk";
};

/**
 * 유효한 메시지 데이터인지 확인하는 타입 가드
 *
 * @param data - 확인할 메시지 데이터
 * @returns 유효한 IframeMessageData인 경우 true
 */
export const isValidMessageData = (data: any): data is IframeMessageData => {
  return typeof data === "object" && data !== null;
};
